// localStorage persistence for the array of open Quick Capture drafts.
import { nextCascadePos } from './captureLayout'

export const DRAFTS_KEY = 'quickCapture_drafts'
export const LEGACY_KEY = 'quickCapture_draft' // the pre-multi single-draft key

const newId = () => `qc_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`

// Load the open-drafts array. Falls back to [] on any error. Performs a one-time
// migration: if the new key is absent but the legacy single-draft key exists, seed
// the array with that one draft (fresh id + base position) and delete the old key.
export const loadDrafts = () => {
  try {
    const raw = localStorage.getItem(DRAFTS_KEY)
    if (raw) {
      const parsed = JSON.parse(raw)
      return Array.isArray(parsed) ? parsed : []
    }
    // No new-key value — try the legacy migration.
    const legacyRaw = localStorage.getItem(LEGACY_KEY)
    if (legacyRaw) {
      const legacy = JSON.parse(legacyRaw)
      localStorage.removeItem(LEGACY_KEY)
      if (legacy && typeof legacy === 'object') {
        return [{
          id: newId(),
          body: legacy.body || '',
          scopeLabel: legacy.scopeLabel || '',
          scopeProject: legacy.scopeProject || null,
          attachments: Array.isArray(legacy.attachments) ? legacy.attachments : [],
          pos: nextCascadePos(0),
          minimized: false,
        }]
      }
    }
    return []
  } catch (e) {
    return []
  }
}

// Persist the open-drafts array. Best-effort — quota/serialization errors are swallowed.
export const saveDrafts = (drafts) => {
  try {
    localStorage.setItem(DRAFTS_KEY, JSON.stringify(drafts))
  } catch (e) { /* ignore quota errors */ }
}
